// context/AuthContext.js
import React, { createContext, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../config/firebase";
import { setUser, clearUser, setLoading } from '../store/slices/authSlice';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const dispatch = useDispatch();
    const { user, loading } = useSelector(state => state.auth);

	useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                try {
                    const userDoc = await getDoc(doc(db, "users", firebaseUser.uid));
                    const userData = userDoc.data();
                    
                    // Add only the necessary user data to Redux
                    dispatch(setUser({
                        uid: firebaseUser.uid,
                        email: firebaseUser.email,
                        name: userData?.name,
                        role: userData?.role,
                        hasActiveSubscription: userData?.hasActiveSubscription,
                        currentSubscriptionId: userData?.currentSubscriptionId,
                    }));
                } catch (error) {
                    console.error("Error fetching user data:", error);
                    dispatch(setLoading(false));
                }
            } else {
                dispatch(clearUser());
            }
        });

        return () => unsubscribe();
    }, [dispatch]);

	const value = {
		user,
		loading,
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

